import { render, staticRenderFns } from "./GesCapacitacion.vue?vue&type=template&id=4c67c02d&scoped=true&"
import script from "./GesCapacitacion.vue?vue&type=script&lang=js&"
export * from "./GesCapacitacion.vue?vue&type=script&lang=js&"
import style0 from "./GesCapacitacion.vue?vue&type=style&index=0&id=4c67c02d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c67c02d",
  null
  
)

export default component.exports